module.exports = __webpack_public_path__ + "img/BILLING.4f7b9521.png";